// extracted by mini-css-extract-plugin
module.exports = {"circle":"OutOfStock_circle__u_vcN","icon":"OutOfStock_icon__YLeDj","outOfStock":"OutOfStock_outOfStock__26lRO"};